/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import {
  Layout,
  Topbar,
  Content,
  Sidebar,
  Toolbar,
} from "modules/report-builder/layout";
import Button from "components/button";
import { editReport } from "state/reports/actions";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import ReportPreview from "modules/report-builder/report-preview";
import EditReportName from "modules/report-builder/edit-report-title";
import SelectChartType from "modules/report-builder/select-chart-type";

/**
 * Style dependencies
 */
import "./styles.scss";

const CustomizeStep = ({ reportId, goToStep, goToNextStep, ...props }) => {
  const canSave = false;

  return (
    <Layout>
      {({ classes, innerWrapperClasses }) => {
        return (
          <Box className={classes}>
            <Topbar>
              <>
                <Box>
                  <Button link="/" lined>
                    Exit
                  </Button>
                </Box>
                <EditReportName />
                <Box>
                  <Button secondary disabled={!canSave}>
                    Save
                  </Button>
                </Box>
              </>
            </Topbar>
            <Toolbar>
              <Box />
              <Box>
                <Button onClick={() => goToStep("2")}>Data</Button>
                <Button active onClick={() => goToStep("3")}>
                  Visualization
                </Button>
              </Box>
              <Box />
            </Toolbar>
            <Box className={innerWrapperClasses}>
              <Sidebar spacing={null}>
                <SelectChartType />
              </Sidebar>
              <Content>
                <ReportPreview />
              </Content>
            </Box>
          </Box>
        );
      }}
    </Layout>
  );
};

export default connect(
  (state) => ({
    reportId: getBuilderReportId(state),
  }),
  {
    editReport,
  }
)(CustomizeStep);
